import React, { useState, useEffect, useRef, useMemo, } from 'react'
import { FiSend } from 'react-icons/fi'
import { useTranslation } from 'react-i18next'
import axiosInstance from '../api/axiosInstance'
import { portInUseForAPI } from './../api/axiosInstance'

const MessageBox = ({ po, sku,  onClose, vendorId, getUnseenMessage, messageUnreadCount, isMessageView, markasRead }) => {
  const [messages, setMessages] = useState([])
  const [newMessage, setNewMessage] = useState('')
  const [loading, setLoading] = useState(true)
  const latestMessageIdRef = useRef(null)
  const openbox = useRef(null)
  const user = JSON.parse(localStorage.getItem('userData'))
  const role = localStorage.getItem('role')
  const { t } = useTranslation()
  const { Typeyourmessage, MaximumLimitErrorMessage,SpecialCharactersErrorMessage } = t('MessageBOXpage')
  const listRef = useRef(null)
  const messageBox = useRef()
  const bottomScroll = useRef()
  const [errorMessage, setErrorMessage] = useState('');

  const fetchMessages = async () => {
    try {
      const response = await axiosInstance.get(`/api/messages?poNumber=${po}&poSku=${sku}&role=${role}`)

      if (response.data.length > 0) {
        // Check if there are new messages since the last update
        const latestMessageId =
          response.data[response.data.length - 1].messageId

        if (latestMessageIdRef.current === null && messageUnreadCount > 0) {
          latestMessageIdRef.current = latestMessageId
        
          setMessages(response.data)
          markasRead(po, sku)
        }
        if (latestMessageId !== latestMessageIdRef.current) {
          setMessages(response.data)
          latestMessageIdRef.current = latestMessageId
        }
      } else {
        setMessages([])
      }
      setLoading(false)
    } catch (error) {
      setLoading(false)
    }
  }

  const sortedMessages = useMemo(
    () => [...messages].sort((a, b) => new Date(a.timestamp) - new Date(b.timestamp)),
    [messages]
  )

  useEffect(() => {
    setLoading(true)
    fetchMessages()

    if (openbox.current) {
      openbox.current.focus()
    }

  }, [po, sku, role])

  const handleSendMessage = async () => {
    const user = JSON.parse(localStorage.getItem('userData'))
    const newMessageObject = {
      poNumber: po,
      poSku: sku,
      role: role,
      sender: user?.roleName === 'SUPPLIER_ROLE'
        ? user?.supplierName
        : user?.fullName,
      messageContent: newMessage,
      timestamp: new Date(),
      vendorId: user?.roleName === 'SUPPLIER_ROLE' ? user?.supplierId : vendorId // Buyer
    }
    if (!newMessage)
      return alert("Please enter a message")
    try {
      const response = await axiosInstance.post(
        `${process.env.REACT_APP_API_DOMAIN}:${portInUseForAPI}/api/messages`,
        newMessageObject
      )
      setMessages([...messages, response.data])
      setNewMessage('')
    } catch (error) {
    }
  }
  //enter to send a message
  const hanldeEnter = (e) => {
    if (e.key === "Enter" && !errorMessage) {
      handleSendMessage()
    }
  }

  
  useEffect(() => {
    setTimeout(() => {
      bottomScroll.current?.scrollIntoView({ behavior: "smooth" });
    }, 100);
  }, [messages]);

  return (
    <>
      {isMessageView ?
        <>
          <div
            ref={listRef} className='flex-1 min-h-0 overflow-y-auto p-4'
          >
            {loading ? (
              <div className='flex justify-center items-center h-full'>
                <div className='animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-blue-500'></div>
              </div>
            ) : (
              sortedMessages.map((msg, index) => (
                <div
                  key={msg.id ?? msg.messageId ?? index}
                  className={`mb-2 p-2 rounded ${msg.role === role ? 'bg-blue-100 text-right' : 'bg-gray-100 text-left'
                    }`}
                >
                  <div className='text-xs text-gray-500 mb-1'>
                    {msg.sender} - {new Date(msg.timestamp).toLocaleString()}
                  </div>
                  <div>{msg.messageContent}</div>
                </div>
              ))
            )}
          </div>

          {
            user?.userGroupName !== "OVERSEAS_ROLE" && (
              <>
                <div className='flex items-start p-4 border-t border-gray-200 gap-2'>        
                  <div className="flex-1 min-w-0">
                    <input
                      type='text'
                      ref={openbox}
                      value={newMessage}
                      onChange={(e) => {
                        const value = e.target.value;
                    
                        const specialCharRegex = /[^a-zA-Z0-9\s.,!?_-]/;
                    
                        if (specialCharRegex.test(value)) {
                          setErrorMessage(SpecialCharactersErrorMessage);
                        } else if (value.length > 250) {
                          setErrorMessage(MaximumLimitErrorMessage);
                        } else {
                          setErrorMessage("");
                        }
                    
                        setNewMessage(value);
                      }}
                      className="w-full p-2 border border-gray-300 rounded"
                      placeholder={Typeyourmessage}
                      maxLength={251}
                      onKeyUp={hanldeEnter}
                    />

                    <div className="mt-1 text-xs text-red-500">
                      {errorMessage}
                    </div>
                  </div>
                  <div className="flex flex-col items-center">
                    <button
                      onClick={handleSendMessage}
                      disabled={!!errorMessage}
                      className={`p-2 bg-blue-500 text-white rounded flex items-center justify-center ${
                        errorMessage
                          ? 'cursor-not-allowed opacity-50'
                          : 'cursor-pointer'
                      }`}                    >
                      <FiSend size={20} />
                    </button>
                    <span className="mt-3 text-xs text-gray-400 whitespace-nowrap">
                      {newMessage?.length || 0} / 250
                    </span>
                  </div>
                </div>
              </>
            )
          }

        </>
        :


        <div className='fixed z-20 right-0 top-0 w-80 h-full bg-white shadow-lg flex flex-col' ref={messageBox}>
          <div className='flex justify-between items-center p-4 border-b border-gray-200 bg-blue-100'>
            <div className='text-lg font-semibold'>
              {po}-{sku}
            </div>
            <button className='text-red-500 text-bold' onClick={onClose}>
              &#10006;
            </button>
          </div>
          <div className='flex-1 overflow-y-auto p-4'>
            {loading ? (
              <div className='flex justify-center items-center h-full'>
                <div className='animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-blue-500'></div>
              </div>
            ) : (
              messages
                .sort((a, b) => new Date(a.timestamp) - new Date(b.timestamp))
                .map((msg, index) => (
                  <div ref={bottomScroll}
                    key={index}
                    className={`mb-2 p-2 rounded ${msg.role === role
                      ? 'bg-blue-100 self-end text-right'
                      : 'bg-gray-100 self-start text-left'
                      }`}
                  >
                    <div className='text-xs text-gray-500 mb-1'>
                      {msg.sender} - {new Date(msg.timestamp).toLocaleString()}
                    </div>
                    <div>{msg.messageContent}</div>
                  </div>
                ))
            )}
          </div>
          {
            user?.userGroupName !== "OVERSEAS_ROLE" && (
              <div className='flex items-start p-4 border-t border-gray-200 gap-2'>
                <div className="flex-1 min-w-0">
                  <input
                    type='text'
                    ref={openbox}
                    value={newMessage}
                    onChange={(e) => {
                      const value = e.target.value;
              
                      const specialCharRegex = /[^a-zA-Z0-9\s.,!?_-]/;
              
                      if (specialCharRegex.test(value)) {
                        setErrorMessage(SpecialCharactersErrorMessage);
                      } else if (value.length > 250) {
                        setErrorMessage(MaximumLimitErrorMessage);
                      } else {
                        setErrorMessage("");
                      }
              
                      setNewMessage(value);
                    }}
                    className="w-full p-2 border border-gray-300 rounded"
                    placeholder={Typeyourmessage}
                    maxLength={251}
                    onKeyUp={hanldeEnter}
                  />

                  <div className="mt-1 text-xs text-red-500">
                    {errorMessage}
                  </div>
                </div>

                <div className="flex flex-col items-center">
                  <button
                    onClick={handleSendMessage}
                    disabled={!!errorMessage}
                    className={`p-2 bg-blue-500 text-white rounded flex items-center justify-center ${errorMessage
                        ? 'cursor-not-allowed opacity-50'
                        : 'cursor-pointer'
                      }`}
                  >
                    <FiSend size={20} />
                  </button>
                  <span className="mt-3 text-xs text-gray-400 whitespace-nowrap">
                    {newMessage?.length || 0} / 250
                  </span>
                </div>
              </div>
            )
          }
        </div>
      }
    </>
  )
}

export default MessageBox
